










































































import Vue from 'vue';
import { simpleSearch } from '~/services/search';

export default Vue.extend({
  components: {},
  props: {
    data: {
      type: Object,
      default: null,
    },
    props: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedService: '',
      search: '',
    };
  },
  mounted() {
    (this.$refs.searchInput as any).focus();
  },
  methods: {
    selectService(id: string) {
      this.selectedService = id;
    },
    getFilteredSkills() {
      // console.log(this.props.jobs);
      // console.log(this.props.skils);
      const skillsResult = this.props.skills.filter((skill: any) => {
        return simpleSearch(this.$loc(skill.localizedTitle), this.search);
      });
      const jobsResult = this.props.jobs.filter((job: any) => {
        return (
          job.localizedTitle &&
          this.$loc(job.localizedTitle) &&
          simpleSearch(this.$loc(job.localizedTitle), this.search)
        );
      });
      return [...skillsResult, ...jobsResult];
    },
    focusSearch() {
      (this.$refs.searchInput as any).focus();
    },
    selectJob(job: any) {
      const skill = this.props.skills.reduce((prev: any, next: any) => {
        if (next.id === job.skillId) {
          return next;
        }
        return prev;
      }, null);
      const ev1 = {
        focusNext: false,
        key: 'skill',
        sectionKey: 'skill',
        value: {
          skillId: job.skillId,
          textValue: this.$loc(skill.localizedTitle),
        },
      };
      this.$emit('save', ev1);
      const eventData = {
        focusNext: true,
        key: 'job',
        sectionKey: 'job',
        value: {
          jobId: job.id,
          estimate: job.estimate,
          textValue: this.$loc(job.localizedTitle),
        },
      };
      this.$emit('save', eventData);
    },
    selectSkill(skill: any) {
      const eventData = {
        focusNext: true,
        key: 'skill',
        value: {
          skillId: skill.id,
          textValue: this.$loc(skill.localizedTitle),
        },
      };
      this.$emit('save', eventData);
    },
  },
});
